import defaults from 'lodash/defaults';

import {
  DEFAULT_FLEX_LAYOUT,
  flexValueToCss,
  numberToPx,
  paddingToCss,
} from './flexContext';

export const FLEX_MIN_HEIGHT = 200;

export function alignmentMultiplier(alignment) {
  if (alignment === 'right') return 1;
  if (alignment === 'left') return 0;
  return 0.5;
}

export function getFlexInnerGridStyles({
  stretched = false,
  minWidth,
  alignment = 'center',
  mobile = false,
  isFreeSize = false,
} = {}) {
  if (mobile || isFreeSize || !stretched || !minWidth) {
    return { width: '100%' };
  }

  return {
    width: `${minWidth}px`,
    marginLeft: `calc((100% - ${minWidth}px) * ${alignmentMultiplier(alignment)})`,
  };
}

export function flexContainerStyles(flexLayout, { baseDefaults = DEFAULT_FLEX_LAYOUT, childCount } = {}) {
  const layout = defaults({}, flexLayout, baseDefaults);
  const styles = {
    height: 'auto',
    display: 'flex',
    flexDirection: flexValueToCss(layout.flexDirection),
    justifyContent: flexValueToCss(layout.justifyContent),
    alignItems: flexValueToCss(layout.alignItems),
    alignContent: flexValueToCss(layout.alignContent),
    flexWrap: flexValueToCss(layout.flexWrap),
    columnGap: numberToPx(layout.gap),
    rowGap: numberToPx(layout.gap),
    padding: paddingToCss(layout.padding),
    ...(layout.minHeight != null ? { minHeight: numberToPx(layout.minHeight) } : {}),
    boxSizing: 'border-box',
  };

  if (childCount === 0) {
    styles.minHeight = `${FLEX_MIN_HEIGHT}px`;
  }

  return styles;
}
